import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { HiMail } from 'react-icons/hi';
import { Link } from 'react-scroll';
let url="https://github.com/iamtheabhishekdas";
let url1="https://www.linkedin.com/in/iamtheabhishekdas/";
const SocialMedia = () => (
  <div className="app__social">
    <div>
    <a href={url} target="_blank"><BsGithub /></a>
      
    </div>
    <div>
    <a href = "mailto:theabhishekdas279@gmail.com?subject = Feedback&body = Message"><HiMail /></a>
      
    </div>
    <div>
    <a href={url1} target="_blank"><BsLinkedin /></a>
      
    </div>
  </div>
);

export default SocialMedia;
